"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '500px',
  margin: theme.spacing(3),
  gap: theme.spacing(3)
}));
const StyledTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  fontWeight: 'bold',
  textAlign: 'center'
}));
const InfoCircleIcon = (0, _mui.styled)(_icons.InfoCircle)(({
  theme
}) => ({
  fontSize: '60px',
  color: theme.palette.default.main
}));
const PendingRegistrationPage = () => {
  const handleRedirectHomePage = (0, _react.useCallback)(() => {
    window.location.href = '/';
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(InfoCircleIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      variant: "h5",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.ParentalConsentPendingPageTitle,
        id: _models.TranslationKey.ParentalConsentPendingPageTitle
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body1",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.ParentalConsentPendingPageDescription,
        id: _models.TranslationKey.ParentalConsentPendingPageDescription
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      variant: "contained",
      color: "primary",
      sx: {
        marginTop: 3
      },
      onClick: handleRedirectHomePage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.ParentalConsentPendingExplore,
        defaultMessage: _constants.defaultTranslations.ParentalConsentPendingExplore
      })
    })]
  });
};
var _default = exports.default = PendingRegistrationPage;
//# sourceMappingURL=PendingRegistrationPage.js.map